interface MultiSelectChipsProps {
  options: string[];
  selected: string[];
  onChange: (selected: string[]) => void;
}

export default function MultiSelectChips({ options, selected, onChange }: MultiSelectChipsProps) {
  const toggle = (option: string) => {
    if (selected.includes(option)) {
      onChange(selected.filter((s) => s !== option));
    } else {
      onChange([...selected, option]);
    }
  };

  return (
    <div className="flex flex-wrap gap-2">
      {options.map((option) => {
        const isSelected = selected.includes(option);
        return (
          <button
            key={option}
            type="button"
            onClick={() => toggle(option)}
            className={`whitespace-nowrap px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 min-h-[48px] cursor-pointer ${
              isSelected
                ? 'bg-coral text-white border-2 border-coral'
                : 'bg-white text-text-secondary border-2 border-border-color hover:border-coral/40'
            }`}
          >
            {option}
          </button>
        );
      })}
    </div>
  );
}